import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon } from "@ui5/webcomponents-react";
import { PieChart } from "@ui5/webcomponents-react-charts";
import "@ui5/webcomponents-icons/dist/AllIcons.js";

const ExpenseStatusDistributionCard = ({ expenseData }) => {
  const [statusDistribution, setStatusDistribution] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [pendingReviewCount, setPendingReviewCount] = useState(0);

  useEffect(() => {
    const calculateStatusDistribution = () => {
      if (!expenseData || expenseData.length === 0) {
        setStatusDistribution([]);
        setLoading(false);
        setTotalExpenses(0);
        setPendingReviewCount(0);
        return;
      }

      const distribution = {};
      let pendingReview = 0;

      expenseData.forEach((expense) => {
        const status = expense.status;
        distribution[status] = (distribution[status] || 0) + 1;
        if (status === "Pending") {
          pendingReview++;
        }
      });

      const statusDistributionArray = Object.entries(distribution).map(([status, count]) => ({
        name: status,
        users: count
      }));

      setStatusDistribution(statusDistributionArray);
      setTotalExpenses(expenseData.length);
      setPendingReviewCount(pendingReview);
      setLoading(false);
    };

    calculateStatusDistribution();
  }, [expenseData]);

  const statusText = `${pendingReviewCount} Pending Approval`;



  return (
    <Card
      header={<CardHeader avatar={<Icon name="documents" />} status={statusText} subtitleText="Status Distribution" titleText="All Expenses"/>}
      style={{
        marginBottom: "20px"
      }}
    >
      <PieChart
        dataset={statusDistribution}
        dimension={{
          accessor: 'name'
        }}
        measure={{
          accessor: 'users',
		  colors: [
      '#035663',
      '#0070FF'
    ]
        }}
        onClick={() => {}}
        onDataPointClick={() => {}}
        onLegendClick={() => {}}
      />
    </Card>
  );
};

export default ExpenseStatusDistributionCard;

